import { render, staticRenderFns } from "./TabSafety.vue?vue&type=template&id=6a57e29e&scoped=true&"
import script from "./TabSafety.vue?vue&type=script&lang=js&"
export * from "./TabSafety.vue?vue&type=script&lang=js&"
import style0 from "./TabSafety.vue?vue&type=style&index=0&id=6a57e29e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a57e29e",
  null
  
)

export default component.exports